<template>
    <jet-dialog-modal :show="show" v-if="show" @close="handleCancel">
        <template #title>
            Credit Overage Confirmation
        </template>

        <template #content>
            <div class="mb-2">
                This message will exceed your current plan limit of {{  creditLimitAvailabilityResponse.plan_limit }} credits by {{ creditLimitAvailabilityResponse.overage_credits }} credits. <br />
            </div>

            <ul class="list-disc list-inside font-bold mb-4 mt-4">
                <li>
                    Estimated Additional Charge: ${{ overageAmount }} ({{ creditLimitAvailabilityResponse.overage_credits }} credits at {{ creditLimitAvailabilityResponse.overage_rate }} ¢ per credit)
                </li>
            </ul>
            <div class="mb-2 mt-2">
                You can continue to send messages at a rate of <span class='font-bold'>{{ creditLimitAvailabilityResponse.overage_rate }} ¢ per credit </span>
                or you can upgrade your account to a new plan today and save. <br /><br />

                <span class="font-italic">Charges are estimated based on 100% message delivery rate. We do not charge for failed messages.</span>
            </div>
        </template>

        <template #footer>
            <jet-button text class="normal-case text-16px" @click.native="handleConfirm">
                <span class='font-normal tracking-normal'>Confirm Additional Charge</span>
            </jet-button>
                
            <a :href="route('subscriptions.index')" @click="handleCancel" class="w-full text-center" target="_blank">
                <jet-button class="" >
                    View Plans
                </jet-button>
            </a>
        </template>
    </jet-dialog-modal>

</template>


<script>

import { useModalStore } from '@/Stores/modal';
import {mapWritableState, mapActions, mapState} from 'pinia';

export default {
    name: 'CreditOverageWarningModal',
    props: ['creditLimitAvailabilityResponse'],
    data() {
        return {
        }
    },
    methods: {
        handleCancel() {
            this.resolve(false)
            this.show = false;
        },
        handleConfirm() {
            this.resolve(true)
            this.show = false;
        },
    },
    computed: {
        ...mapWritableState(useModalStore, ['show', 'resolve']),
        overageAmount() {
            let cents = this.creditLimitAvailabilityResponse.overage_rate * this.creditLimitAvailabilityResponse.overage_credits;
            return (cents / 100).toFixed(2);
        }
    }

}
</script>